 <template>
  <div>
    <v-container fluid class="pt-0">
      <v-row>
        <v-col cols="12" md="8" class="pt-0">
          <v-row>
            <!-- <v-col cols="12">
            <v-chip-group
              v-model="default_language"
              @change="renderIframe()"
              mandatory
              active-class="primary--text"
            >
              <span
                class="subheading mr-2"
                style="line-height: 32px !important; align-self: center"
                >{{ $t("language") }}:</span
              >
              <v-chip value="sk" filter>SK</v-chip>
              <v-chip value="cs" filter>CS</v-chip>
              <v-chip value="en" filter>EN</v-chip>
            </v-chip-group>
          </v-col> -->
            <v-col cols="12">
              <v-color-picker
                v-model="primary_color"
                hide-mode-switch
                hide-canvas
                mode="hexa"
                @update:color="renderIframe()"
              ></v-color-picker>
            </v-col>
            <v-col cols="12">
              <v-chip-group
                v-model="display_only"
                @change="renderIframe()"
                mandatory
                active-class="primary--text"
              >
                <span
                  class="subheading mr-2"
                  style="line-height: 32px !important; align-self: center"
                  >{{ $t("displayOnly") }}:</span
                >
                <v-chip value="dailyMenu" filter>{{ $t("dailyMenu") }}</v-chip>
                <v-chip value="dishes" filter>{{ $t("dishes") }}</v-chip>
                <v-chip value="both" filter>{{ $t("both") }}</v-chip>
              </v-chip-group>
            </v-col>
            <v-col cols="12" class="d-flex align-center">
              <v-switch
                v-model="floating_button"
                @change="renderIframe()"
                color="primary"
                class="mt-0 mr-4"
                :label="$t('showFloatingButton')"
                hide-details
              ></v-switch>
              <v-switch
                v-model="show_arrows"
                @change="renderIframe()"
                color="primary"
                class="mt-0"
                :label="$t('showArrows')"
                hide-details
              ></v-switch>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="agreements_url"
                :label="$t('agreementsUrl')"
                @blur="renderIframe()"
                rounded
                filled
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="gdpr_url"
                :label="$t('gdprUrl')"
                @blur="renderIframe()"
                rounded
                filled
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                :value="html.replace(`  <base target=&quot;_top&quot;>\n`, ``)"
                :label="$t('htmlCode')"
                rows="10"
                readonly
                auto-grow
                filled
                rounded
                hide-details
              ></v-textarea>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="4" class="pt-0">
          <iframe :srcdoc="html"></iframe>
        </v-col>
      </v-row>
    </v-container>
    <div id="whatsapp"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // default_language: "sk",
      primary_color: "#0360ec",
      display_only: "both",
      floating_button: true,
      show_arrows: true,
      agreements_url: "/",
      gdpr_url: "https://piknik.cc/gdpr",
      html: "",
      htmlTemplate: `<html>
<head>
  <base target="_top">
  <!-- Fonts, icons, responsiveness -->
  <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, minimal-ui" />
  <link href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900" rel="stylesheet" />
  <link href="https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css" rel="stylesheet" />
  <!-- Widget styles -->
  <link href="https://cdn.jsdelivr.net/gh/sjasik/embeddable.piknik.cc@latest/css/app.css" rel="stylesheet" />
  <!-- Stripe payment gateway -->
  <script src="https://js.stripe.com/v3/"><\/script>
</head>
<body>
  <!-- Widget element -->
  <piknik-embeddable
    restaurant_id="RESTAURANT_ID"
    primary_color="PRIMARY_COLOR"
    display_only="DISPLAY_ONLY"
    floating_button="FLOATING_BUTTON"
    show_arrows="SHOW_ARROWS"
    agreements_url="AGREEMENTS_URL"
    gdpr_url="GDPR_URL"
  ></piknik-embeddable>
</body>
<!-- Widget script -->
<script src="https://cdn.jsdelivr.net/gh/sjasik/embeddable.piknik.cc@latest/js/app.js"><\/script>
</html>`,
    };
  },
  mounted() {
    this.renderIframe();

    $("#whatsapp").venomButton({
      phone: "+421950466441",
      avatar:
        "https://cdn.jsdelivr.net/gh/sjasik/piknik.cc@latest/images/whatsapp/avatar.png",
      buttonImage:
        "https://cdn.jsdelivr.net/gh/sjasik/piknik.cc@latest/images/whatsapp/icon.svg",
      nameClient: "Piknik",
      headerTitle: this.$t("usuallyRepliesWithinTheHour"),
      chatMessage: this.$t("whatsappChatMessageWidget"),
      placeholder: this.$t("yourMessage"),
      showPopup: true,
      position: "right",
      size: "64px",
      buttonColor: "#25D366",
    });
    setTimeout(() => {
      $("#whatsapp .venom-button-popup").addClass("active");
    }, 2500);
  },
  methods: {
    renderIframe: function () {
      let html = this.htmlTemplate;
      html = html.replace("RESTAURANT_ID", localStorage.restaurantId);
      // html = html.replace("RESTAURANT_ID", "6005db8e3b92fe45b7f930ef");
      // html = html.replace("DEFAULT_LANGUAGE", this.default_language);
      html = html.replace("PRIMARY_COLOR", this.primary_color);
      html = html.replace(
        "DISPLAY_ONLY",
        this.display_only === "both" ? "" : this.display_only
      );
      html = html.replace("FLOATING_BUTTON", `${this.floating_button}`);
      html = html.replace("SHOW_ARROWS", `${this.show_arrows}`);
      html = html.replace("AGREEMENTS_URL", `${this.agreements_url}`);
      html = html.replace("GDPR_URL", `${this.gdpr_url}`);
      this.html = html;
    },
  },
};
</script>

<style scoped>
iframe {
  width: 100%;
  height: 90vh;
  border: none;
}

/deep/ .v-slide-group__content {
  padding: 0 !important;
}
</style>